import { render, staticRenderFns } from "./VincularDocumentoUnidadeForm.vue?vue&type=template&id=267f5dea"
import script from "./VincularDocumentoUnidadeForm.vue?vue&type=script&lang=js"
export * from "./VincularDocumentoUnidadeForm.vue?vue&type=script&lang=js"
import style0 from "./VincularDocumentoUnidadeForm.vue?vue&type=style&index=0&id=267f5dea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports